import checkIcon from '../../../assets/icons/check.svg';
import crossIcon from '../../../assets/icons/cross.svg';
import NoTableData from '../../global-components/NoTableData';

interface Props {
  packages: any;
}
function PackageFields({ packages }: Props) {
  return (
    <table className='table mb_0' id='document_table'>
      <thead className='ubbe-table-header'>
        <tr>
          <th
            scope='col'
            className='text-start align-middle ubbe-table-heading-text'
            // style={{ width: '25%' }}
          >
            QTY
          </th>
          <th
            scope='col'
            className='text-start align-middle ubbe-table-heading-text'
            // style={{ width: '42%' }}
          >
            Package Type
          </th>
          <th
            scope='col'
            className='text-start align-middle ubbe-table-heading-text'
            // style={{ width: '42%' }}
          >
            Description
          </th>
          <th
            scope='col'
            className='text-start align-middle ubbe-table-heading-text'
            // style={{ width: '42%' }}
          >
            Length
          </th>
          <th
            scope='col'
            className='text-start align-middle ubbe-table-heading-text'
            // style={{ width: '42%' }}
          >
            Width
          </th>
          <th
            scope='col'
            className='text-start align-middle ubbe-table-heading-text'
            // style={{ width: '42%' }}
          >
            Height
          </th>
          <th
            scope='col'
            className='text-start align-middle ubbe-table-heading-text'
            // style={{ width: '42%' }}
          >
            Weight
          </th>
          <th
            scope='col'
            className='text-center align-middle ubbe-table-heading-text'
            // style={{ width: '42%' }}
          >
            DG
          </th>
          <th
            scope='col'
            className='text-center align-middle ubbe-table-heading-text'
            // style={{ width: '42%' }}
          >
            Pharma
          </th>
          <th
            scope='col'
            className='text-center align-middle ubbe-table-heading-text'
            // style={{ width: '10%' }}
          >
            Time Sensitive
          </th>
        </tr>
      </thead>
      <tbody id='shipment_document_rows'>
        {packages && packages.length > 0 ? (
          packages.map((item: any, index: number) => (
            <tr>
              <td className={'py-3 align-middle text-start'}>
                {item.quantity}
              </td>
              <td className={'py-3 align-middle text-start'}>
                {item.package_type}
              </td>
              <td className={'py-3 align-middle text-start'}>
                {item.description}
              </td>
              <td className={'py-3 align-middle text-start'}>
                {item['length']}
              </td>
              <td className={'py-3 align-middle text-start'}>{item.width}</td>
              <td className={'py-3 align-middle text-start'}>{item.height}</td>
              <td className={'py-3 align-middle text-start'}>{item.weight}</td>
              <td className={'py-3 align-middle text-center'}>
                <img
                  alt='delete-icon'
                  src={item.is_dangerous_good ? checkIcon : crossIcon}
                  className='packageBoxIcon'
                />
              </td>
              <td className={'py-3 align-middle text-center'}>
                <img
                  alt='delete-icon'
                  src={item.is_pharma ? checkIcon : crossIcon}
                  className='packageBoxIcon'
                />
              </td>
              <td className={'py-3 align-middle text-center'}>
                <img
                  alt='delete-icon'
                  src={item.is_time_sensitive ? checkIcon : crossIcon}
                  className='packageBoxIcon'
                />
              </td>
            </tr>
          ))
        ) : (
          <tr className='w-full'>
            <td colSpan={10}>
              <NoTableData message='No Package Added Yet!' />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default PackageFields;
